export { NewsPage } from './NewsPage';
